import { BLACK_d, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH, PC_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  margin-top: 15rem;
  width: 100%;
  display: flex;
  align-items: center;

  justify-content: space-between;
  & > img {
    position: absolute;
    z-index: -999;
    width: 185rem;
    top: 35rem;
    margin-left: -30rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 33.3rem;
    margin-top: 4rem;
    flex-direction: column;
    gap: 6rem;
    justify-content: center;
    & > img {
      position: absolute;
      z-index: -999;
      width: 37.5rem;
      top: 69rem;
      margin-left: 0;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Wrapper2 = styled.div`
  & > div {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    & > img {
      width: 34.4rem;
      height: 71.5rem;
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    /* & > div {
      & > img {
        width: 26rem;
        height: 54rem;
      }
    } */
  }
`;

export const VideoWrapper = styled.div`
  position: absolute;
  width: 31.06rem;
  height: 65.19rem;
  border-radius: 3rem;
  overflow: hidden;
  & > video {
    width: 100%;
    height: 100%;
    border-radius: 3rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    /* width: 30.06rem;
    height: 49.19rem; */
  }
`;
export const TextBox1 = styled.div`
  width: 71rem;
  font-weight: 700;
  font-size: ${(props) => (props.language === "ko" ? "6.8rem" : "5.6rem")};
  line-height: ${(props) => (props.language === "ko" ? "10rem" : "7.2rem")};
  word-break: keep-all;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    font-size: 3.6rem;
    line-height: ${(props) => (props.language === "ko" ? "6.4rem" : "4.7rem")};
    margin-bottom: 1rem;
    text-align: center;
    & span:nth-child(1) {
      display: block;
    }
  }
`;

export const TextBox2 = styled.div`
  font-weight: 300;
  font-size: 2rem;
  line-height: 3.6rem;
  color: ${BLACK_d};

  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 1rem;
    font-weight: 300;
    font-size: 1.6rem;
    line-height: 2.8rem;
    height: 5.6rem;
    text-align: center;
    display: block;
  }
`;

export const ImgBox1 = styled.div`
  margin-top: 10rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3rem;
  & > img {
    width: 16rem;
    height: 16rem;
  }
  & > div {
    display: flex;
    gap: 2rem;
  }
  & > div > div > a > img {
    width: 15rem;
    height: 4.5rem;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 6rem;
    font-weight: 300;
    align-items: center;
    & > img {
      width: 10rem;
      height: 10rem;
    }
  }
`;
